import { marketingAgentPromptSchema } from "@redotech/redo-model/marketing/marketing-agent-prompt/marketing-agent-prompt-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * RPC schema for retrieving all AI options for SMS templates.
 *
 * If triggerMarketingAgentPromptId is provided, returns only Strategy prompts
 * that support that trigger. If not provided, returns all strategies and all
 * trigger prompts for selection.
 */
export const getSmsTemplateAiOptions = {
  name: "getSmsTemplateAiOptions" as const,
  input: z.object({
    triggerMarketingAgentPromptId: zExt.objectId().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    strategyPrompts: z.array(marketingAgentPromptSchema),
    triggerPrompts: z.array(marketingAgentPromptSchema).optional(),
  }),
};
